<template>
    <div
        ref="console-log"
        class="app-ai-relay-history">
        <div v-for="(item, index) in history">
            <div 
                class="app-ai-relay-history__item app-ai-relay-history__item--user"
                :data-item="item.id"
                v-if="!item.message_type">
                    <p class="app-ai-relay-history__item-name">You</p>
                    <div class="app-ai-relay-history__response">
                        <button
                            v-if="index > 0"
                            @click="toggleActions(item.id)"
                            type="button"
                            class="element-button--icon element-button">
                            <svg class="element-icon--delete element-icon" width="1em" height="1em"><use href="/img/icons.svg#icon-delete"></use></svg>
                        </button>
                        <pre>{{ item.user_query }}</pre>
                    </div>
            </div>
            <div v-if="index > 0 && currentId && currentId === item.id" class="message--ai-delete message warning">
                <p>You’ll be deleting this message and all subsequent responses below, are you sure?</p>
                <div class="message__actions">
                    <button
                        @click="toggleActions(item.id, true)"
                        title="Dismiss"
                        class="element-button--text element-button"
                        >
                        Cancel
                    </button>
                    <button
                        @click="removeItem(item.id)"
                        title="Remove below history"
                        class="element-button--text element-button">
                        Delete
                    </button>
                </div>
            </div>
            <div
                :class="['app-ai-relay-history__item app-ai-relay-history__item--ai', { 'request-log__loading': item.loading }]"
                v-if="!item.message_type">
                    <p class="app-ai-relay-history__item-name">AI</p>
                    <div class="app-ai-relay-history__response">
                        <pre>{{ item.ai_response }}</pre>
                    </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    components: {

    },
    props: {
        source: {
            type: Array,
            default: () => []
        },
    },
    data () {
        return {
            history: this.source ?? [],
            currentId: null,
            isProcessing: false
        }
    },
    computed: {

    },
    watch: {
        source (value) {
            this.history = value
        },
        async history (value) {
            await this.$nextTick()
            if (this.$refs['console-log'])
                this.$refs['console-log'].scrollTop = this.$refs['console-log'].scrollHeight
        },
    },
    methods: {
        toggleActions (id, close) {
            if (this.isProcessing)
                return false

            if (this.currentId && this.currentId === id || close === true)
            {
                this.currentId = null
                return false
            }

            this.currentId = id
        },
        async removeItem (id) {

            if (this.isProcessing)
                return false

            this.isProcessing = true
            this.currentId = null
            let ids = [id]
            let found = false
            _.forEach(this.history, function(item) {
                if (found === true)
                {
                    ids.push(item.id)
                    return
                }
                if (item.id === id)
                    found = true
            })

            // generate an array of Message IDs starting from the passed ID onwards and pass them in the payload
            await this.$emit('removeItemFromHistory', ids)

            this.isProcessing = false
        }
    },
}
</script>
